import EditReceipt from './EditReceipt';

export default EditReceipt;
